import { BaseServices, HttpMethod } from '@services/base'

export interface FinalizarPropostaType {
  codigoProposta: string
  cpf: string
  email: string
  telefone: string
  produto: string
}

export type PostPropostaFinalizarWebServiceType = (
  data: FinalizarPropostaType,
  accessToken?: string,
) => Promise<unknown>

export default async (data: FinalizarPropostaType) => {
  const pathname = process.env.REACT_APP_PROPOSTA_FINALIZAR_APP
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {}

  const response = await BaseServices.request({
    headers,
    pathname,
    method,
    host,
    data,
  })
  return response
}
